<div class="spare-parts-container">

  <h2>Configuración de Parámetros</h2>

  <!-- ===== Sección info (solo lectura) ===== -->
  <div class="params-grid">

    <div class="params-field">
      <label for="openingDate">Fecha Programada de Apertura del Sistema:</label>
      <p-datepicker id="openingDate" [readonlyInput]="true" [showTime]="true"
        [(ngModel)]="parameterParts.openingDate" [disabled]="true"></p-datepicker>
    </div>

    <div class="params-field">
      <label for="status">Estado del Sitio:</label>
      <input type="text" pInputText pKeyFilter="alpha" [(ngModel)]="parameterParts.status"
        id="status" [readOnly]="true" [disabled]="true">
    </div>

    <div class="params-field">
      <label for="lastParameterDate">Fecha Programada de Generación del Consolidado:</label>
      <p-datepicker id="lastParameterDate" [readonlyInput]="true"
        [(ngModel)]="parameterParts.generatingMix" [disabled]="true"></p-datepicker>
    </div>

    <div class="params-field">
      <label for="closingDate">Fecha Programada de Cierre del Sistema:</label>
      <p-datepicker id="closingDate" [readonlyInput]="true" [showTime]="true"
        [(ngModel)]="parameterParts.closingDate" [disabled]="true"></p-datepicker>
    </div>

    <div class="params-field"><!-- vacío --></div>

    <div class="params-field">
      <label for="actualTimeSet">Hora Programada Para la Generación del Consolidado:</label>
      <input type="text" pInputText pKeyFilter="alpha" [(ngModel)]="parameterParts.generatingTime"
        id="actualTimeSet" [readOnly]="true" [disabled]="true">
    </div>

  </div>

  <!-- ===== Sección editable (card) ===== -->
  <form [formGroup]="partsForm" (ngSubmit)="save()" class="params-form-card">

    <div class="params-grid">

      <div class="params-field">
        <label for="openingDateSet">Configurar Fecha de Inicio del Próximo Cierre:</label>
        <p-datepicker id="openingDateSet" formControlName="openingDate" [required]="true"
          [showTime]="true" [showSeconds]="true" [stepMinute]="20"></p-datepicker>
      </div>

      <div class="params-field">
        <label for="closingDateSet">Configurar Fecha de Cierre del Próximo Cierre:</label>
        <p-datepicker id="closingDateSet" formControlName="closingDate" [required]="true"
          [showTime]="true" [showSeconds]="true" [stepMinute]="20"></p-datepicker>
      </div>

      <div class="params-field">
        <label for="generatingDateSet">Configurar Fecha del Consolidado del Archivo:</label>
        <p-datepicker id="generatingDateSet" formControlName="generatingDate" [required]="true"
          [showTime]="true" [showSeconds]="true" [stepMinute]="20"></p-datepicker>
      </div>

    </div>

    <div class="button-container">
      <div class="button-container1">
        <button pButton type="button" (click)="toggleStatus()" label="Cambiar Estado del Sitio"
          pTooltip="Se abrirá o cerrará el sitio dependiendo del estado actual."></button>
        <button pButton type="submit" label="Enviar parámetros"
          pTooltip="No olvides insertar la fecha."></button>
      </div>
    </div>

  </form>

</div>
